export default "<span class=\"drag-text\">{{ vm.dragText }}</span> ";